const DONATION_CART_SELECTOR = '[data-fjs-donation-cart]';

document.addEventListener('input', (event) => {
  const input = event.target;

  if (!(input instanceof HTMLInputElement)) return;

  const donationCart = input.closest(DONATION_CART_SELECTOR);
  if (!donationCart) return;

  const donationForm = input.closest('form');
  if (!donationForm || !donationCart.contains(donationForm)) return;

  if (input.type === 'radio') {
    const variantId = input.dataset.variantId;
    const idInput = donationForm.querySelector('input[name="id"]');

    if (!variantId || !(idInput instanceof HTMLInputElement)) return;

    idInput.value = variantId;
    donationForm.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    return;
  }

  if (input.type === 'number') {
    const quantityInput = donationForm.querySelector('input[name="quantity"]');

    if (quantityInput instanceof HTMLInputElement) {
      quantityInput.value = input.value;
    }
  }
});
